import { Button, Form, Input, Select } from 'antd'
import { FC } from 'react'
import { relayStore } from '../store/relay'
import { useNavigate, useParams } from 'react-router-dom'
import { RNRelay } from '../helpers/routeNames'
import { PageBreadcrumb } from '../components/PageBreadcrumb'

export const CreateRelay: FC = () => {
	const [form] = Form.useForm()
	const { relayTypeId } = useParams()
	const { createRelay, relayTypes } = relayStore()
	const navigate = useNavigate()

	const handleSubmit = (values: any) => {
		createRelay(values)
		navigate(RNRelay)
	}

	const relayTypeName = relayTypes.find((rt) => rt.id === relayTypeId)?.name

	return (
		<>
			<PageBreadcrumb
				items={[
					{ label: 'Реле', path: RNRelay },
					{ label: relayTypeName || 'Тип реле' },
					{ label: 'Создать реле' }
				]}
			/>
			<header>
				<h1>Создать реле</h1>
			</header>
			<main>
				<Form
					onFinish={handleSubmit}
					form={form}
					initialValues={{ relayTypeId }}>
					<Form.Item
						label="Название"
						name="name"
						rules={[{ required: true }]}>
						<Input />
					</Form.Item>
					<Form.Item
						label="Срок службы"
						name="expiration"
						rules={[{ required: true }]}>
						<Input />
					</Form.Item>
					<Form.Item
						label="Тип реле"
						name="relayTypeId"
						rules={[{ required: true }]}>
						<Select
							disabled
							options={relayTypes.map((type) => ({
								value: type.id,
								label: type.name
							}))}
						/>
					</Form.Item>
					<Form.Item>
						<Button htmlType="submit">Создать</Button>
					</Form.Item>
				</Form>
			</main>
		</>
	)
}
